const inflightByTypesKey = new Map();

export function invalidateEmailTemplateListCache(templateType, passwordTemplateType) {
  inflightByTypesKey.delete(`${templateType}|${passwordTemplateType}`);
}

export function fetchEmailTemplatesForTypes(
  api,
  templateType,
  passwordTemplateType
) {
  const key = `${templateType}|${passwordTemplateType}`;
  const existing = inflightByTypesKey.get(key);
  if (existing) return existing;

  const promise = api
    .search({
      apiEntity: "emailTemplate",
      searchQuery: {
        type: { $in: [templateType, passwordTemplateType] },
      },
      pageSize: 200,
      sort: { by: "name", order: "asc" },
      byAggregation: false,
    })
    .then((res) => {
      const docs = Array.isArray(res?.docs) ? res.docs : [];
      return {
        templates: docs.filter((doc) => doc.type === templateType),
        passwordTemplates: docs.filter(
          (doc) => doc.type === passwordTemplateType
        ),
      };
    })
    .catch((error) => {
      inflightByTypesKey.delete(key);
      throw error;
    });

  inflightByTypesKey.set(key, promise);
  return promise;
}
